import React from "react";

// Heading — display and section headings (Franie)
// Sizes follow a logical scale from nav labels up to hero display
const sizes = {
  xs:  "text-[11px] font-bold tracking-[0.08em]",        // 11px — all-caps labels, badge text
  s:   "text-[13px] font-semibold",                       // 13px — nav items, small subheadings
  md:  "text-[18px] font-semibold leading-[1.4]",         // 18px — card subheadings
  lg:  "text-[22px] font-semibold leading-[1.35] md:text-[20px]",   // 22px — section subtext
  xl:  "text-[30px] font-semibold leading-[1.2] md:text-[26px] sm:text-[22px]",  // 30px — use case heads
  "2xl": "text-[44px] font-semibold leading-[1.15] md:text-[36px] sm:text-[30px]", // 44px — section headings
  "3xl": "text-[56px] font-semibold leading-[1.1] md:text-[42px] sm:text-[34px]",  // 56px — Why/Problem
  "4xl": "text-[96px] font-bold leading-[1.05] md:text-5xl sm:text-[42px]",        // 96px — hero
  "5xl": "text-[112px] font-bold leading-[1.0] md:text-5xl sm:text-[40px]",        // 112px — max display
  "6xl": "text-[80px] font-semibold leading-[1.1] md:text-5xl sm:text-[40px]",    // 80px — panel headings
};

const Heading = ({ children, className = "", size = "md", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component
      className={`text-white-A700 font-franie ${sizes[size] ?? sizes["md"]} ${className}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Heading };
